<div class="main-container">
  <section class="top-section">
    <cp-logo></cp-logo>
  </section>
  <section class="back-home-section">
    <go-back></go-back>
  </section>

  <div class="flow-container">
    <div class="">
      <section class="new-password-container" [formGroup]="form">
        <h1>New Password</h1>
        <label for="">New Password</label>
        <gbui-input
          formControlName="password"
          password
          [ngClass]="{
            'has-error-test':
              !form.controls['password'].valid &&
              form.controls['password'].touched
          }"
          placeholder="Enter your new password"
        ></gbui-input>
        <p
          class="scale-up-ver-top"
          *ngIf="
            !form.controls['password'].valid &&
            form.controls['password'].touched
          "
        >
          {{ getPasswordErrorMessage('password') }}
        </p>

        <label for="">Confirm New Password</label>
        <gbui-input
          formControlName="confirmPassword"
          password
          [ngClass]="{
            'has-error-test':
              !form.controls['confirmPassword'].valid &&
              form.controls['confirmPassword'].touched
          }"
          placeholder="Enter your new password"
        ></gbui-input>
        <p
          class="scale-up-ver-top"
          *ngIf="
            !form.controls['confirmPassword'].valid &&
            form.controls['confirmPassword'].touched
          "
        >
          {{ getPasswordErrorMessage('confirmPassword') }}
        </p>
        <gbui-button
          [disabled]="form.invalid"
          (click)="changePassword()"
          class="buttons-outline"
          type="submit"
          >Save</gbui-button
        >
      </section>
    </div>
  </div>
</div>
